import React from 'react'
import SarasInput from '../../input/textField/SarasInput'
import * as fn from '../../../helper/uiFunctions';

//sample code for study
//https://www.pluralsight.com/guides/handling-multiple-inputs-with-single-onchange-handler-react

//input from server theb update.

const FormHHMMInput = (props) => {
    //this should be default format for reading props for all form controls
    const { formObject, action, rowKey, headerKey, ...restProps } = props;
    // console.log('data', rowKey, action.paramName, formObject);

    //set server side values for auto complete
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    // let acData;
    // if(dataProcessingFun){
    //     acData = dataProcessingFun(viewData);
    // }
    //pass this handle to the input control and ensure it returns the selected value
    //in case of ac value should contain an object {key: val, text: text to display}
    const onInputChange = (e, value) => {
        //convert the hh:mm input to the minutes
        let minVal = fn.convertHHMMFormatToMinuets(value);
        
        // console.log("hhmm changed", value, minVal);

        if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, minVal);

        //send the parameters reqired by the form
        if (action.actionId) formObject.onFormAction(action, rowKey, headerKey);
    }

    //render input or ac or dp control from input library based on action.InputType 
    //- see sample usage in PocViewer.js
    //NOTE: do not render label control
    //NOTE: use formObject.getState(action.paramName) to get the value for this input
    if((viewData) && hide === "0"){
        let val = fn.convertMinutesToHHMM(viewData.val);

        return (
            <SarasInput onChange={onInputChange} type={action.InputType} value={val}  {...restProps} />
        )
    }

    return (null);
}

export default FormHHMMInput;
